export default __webpack_public_path__ + "static/media/legarconaufusil.d51f0839.png";